module.exports = __webpack_public_path__ + "r-v3/img/mobile_premium_feature_003.f3705780.jpg";